module.exports = __webpack_public_path__ + "img/loading_new.1a4efbab.png";